import FriendLandingTemplate from '../../scenes/Friends/templates/FriendLandingTemplate';

export default FriendLandingTemplate;
